import { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setConfiguration } from '../../../store/actions'
import { CONTENT_MODE } from '../../../utilities/constants'

const Main = ({ children }) => {
    const dispatch = useDispatch()
    const ref = useRef()
    const contentMode = useSelector(_ => _.data.configuration.contentMode)
    const contentModeRef = useRef(contentMode)
    
    useEffect(() => {
        contentModeRef.current = contentMode
    }, [contentMode])   

    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            const { width } = entries[0].contentRect

            const contentMode = width > 768 ?
                CONTENT_MODE.DESKTOP :
                CONTENT_MODE.MOBILE
            
            if (contentMode !== contentModeRef.current ) {
                setTimeout(() => dispatch(setConfiguration({ contentMode })), 0)
            }
        })

        if (ref.current)
            resizeObserver.observe(ref.current)

        return () => { resizeObserver.disconnect() }
    })

    return (
        <main id="main" className={'main--' + CONTENT_MODE.DESKTOP.toLowerCase() } ref={ref}>
            {children}
        </main>
    )
}

export default Main